/* Stylesheet */

.filter_item {
  height: 46px;
  --background: transparent;
  --color: var(--ion-color-text-secondary);

  .label {
    display: flex;
    align-items: center;

    .icon {
      margin: 0px 12px 0px 0px;
    }
  }
}
